import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose, withProps } from 'recompose';

import { setFilterByAppointmentStatus } from 'modules/queues/Schedule/actions/appointmentsFilters';
import { APPOINTMENT_STATUSES } from 'modules/queues/constants/appointmentsFilters';
import { FilterByAppointmentStatus } from 'modules/queues/common/components/AppointmentsFilter';


const getIconTooltipMessage = (intl, activeFilters) => {
  if (!activeFilters.length) {
    return intl.formatMessage({
      id: 'Appointments.AppointmentsList.Filter.FilterOption.AppointmentStatus.Title',
      defaultMessage: '** Appointment state',
    });
  }

  return APPOINTMENT_STATUSES
    .filter(({ key }) => activeFilters.includes(key))
    .map(({ label }) => intl.formatMessage(label))
    .join(', ');
};

export default compose(
  injectIntl,
  connect(
    (state) => ({
      appointmentStatuses: state.queues.schedule.appointmentsFilters.appointmentStatuses,
    }),
    { setFilterByAppointmentStatus },
  ),

  withProps(({ intl, appointmentStatuses }) => ({
    fields: APPOINTMENT_STATUSES,
    iconTooltipMessage: getIconTooltipMessage(intl, appointmentStatuses),
  })),
)(FilterByAppointmentStatus);
